import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MaterialPdfViewerComponent } from '../material-pdf-viewer/material-pdf-viewer.component';
import { MatTooltipModule } from '@angular/material/tooltip';

declare let $: any;

@Component({
  selector: 'app-material-pdf-viewer-pop-up',
  templateUrl: './material-pdf-viewer-pop-up.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatToolbarModule,
    MaterialPdfViewerComponent,
    MatTooltipModule,
  ]
})
export class MaterialPdfViewerPopUpComponent implements OnInit {
  previewFileId!: string;
  filePreviewDialogModal: any | undefined;
  filePreviewTitle!: string;
  _show!: boolean;

  @Input() set show(s: boolean) {
    if(this.previewFileId) {
      this.filePreviewDialogModal = $(`#${this.previewFileId}`).modal();
      if(s) {
        this.filePreviewDialogModal.show();
      } else {
        this.filePreviewDialogModal.hide();
      }
      this._show = s;
    }
  }

  @Output() showChange =  new EventEmitter<boolean>();

  @Input() set fileId(f: string) {
    this.previewFileId = f;
  }

  @Input() set title(t: string) {
    this.filePreviewTitle = t;
  }

  ngOnInit(): void {
    if(this.previewFileId) {
      this.filePreviewDialogModal = $(`#${this.previewFileId}`).modal();
    }
  }

  closeFilePreview() {
    this.filePreviewDialogModal.hide();
    this._show = false;
    this.showChange.emit(this._show);
  }
}
